import React from 'react'

function NotFound() {
  return <div className="content">Page not found.</div>
}

export default NotFound